import { Serializable } from '../../../core/models/serializable';
import { OccupationCategory } from '../../../shared/models/occupation-category.model';
export class JobseekerWorkExperienceCategoryModel
  implements Serializable<JobseekerWorkExperienceCategoryModel>
{
  public jobseekerWorkExperienceCategoryId: number;
  public jobseekerWorkExperienceId: number;
  public category: OccupationCategory;

  fromObject(obj: any): JobseekerWorkExperienceCategoryModel {
    Object.assign(this, obj);

    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }
}
